var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.titleReadable,
      "breadCrumbs": _vm.breadCrumbs,
      "actions": _vm.actions,
      "chips": _vm.chips
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("components.template.dialog.preview.preview")))]), _c('v-tab', [_vm._v(_vm._s(_vm.$t("sign.DocumentDetail.pdf")))]), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("partner.ActivityLogTable.activity")))])], 1), _c('v-divider'), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_vm.value.isInbound && _vm.value.sellerCompany ? _c('div', {
          staticClass: "pb-6"
        }, [_c('small', {
          staticClass: "v-label v-label--active theme--light ml-2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.seller")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.seller,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.seller.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.seller.ref && _vm.value.seller.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.seller.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm.value.buyerCompany ? _c('div', {
          staticClass: "pb-6"
        }, [_c('small', {
          staticClass: "v-label v-label--active theme--light ml-2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.buyer")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.buyer,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.buyer.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.buyer.ref && _vm.value.buyer.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.buyer.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.VEHICLE,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.invoice.vehicleId'),
            "clearable": true,
            "required": true
          },
          on: {
            "input": _vm.updateVehicleId
          },
          model: {
            value: _vm.value.vehicleId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "vehicleId", $$v);
            },
            expression: "value.vehicleId"
          }
        }), _c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.REPORT,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.invoice.reportId'),
            "clearable": true,
            "required": true
          },
          on: {
            "input": _vm.updateReportId
          },
          model: {
            value: _vm.value.reportId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "reportId", $$v);
            },
            expression: "value.reportId"
          }
        }), _c('select-entity', {
          attrs: {
            "refType": _vm.ResourceEnum.FLEET,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.invoice.fleetId'),
            "clearable": true,
            "required": true
          },
          on: {
            "input": _vm.updateFleetId
          },
          model: {
            value: _vm.value.fleetId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "fleetId", $$v);
            },
            expression: "value.fleetId"
          }
        }), _c('v-divider', {
          staticClass: "pt-2"
        }), _c('group-type-selection-detail-component', {
          model: {
            value: _vm.value,
            callback: function callback($$v) {
              _vm.value = $$v;
            },
            expression: "value"
          }
        })];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('m-action-list', {
          attrs: {
            "divider": true,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_vm.value.isOutbound ? _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": _vm.isMobile ? false : true,
      "max-width": _vm.isMobile ? '' : 800,
      "flat": ""
    }
  }, [_c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUpdateChangesDialogActive,
      expression: "isUpdateChangesDialogActive"
    }]
  }, [_c('v-alert', {
    attrs: {
      "type": "warning",
      "outlined": "",
      "dense": "",
      "border": "left"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center mt-n1 mb-n1"
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSave.unsavedChanges")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isValid,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)])], 1), _c('v-card-text', {
    class: _vm.isMobile ? 'px-0' : ''
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('invoice-form-preview', {
    attrs: {
      "value": _vm.value,
      "readonly": _vm.value.status !== _vm.InvoiceStatusEnum.DRAFT
    }
  })], 1)], 1), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUpdateChangesDialogActive,
      expression: "isUpdateChangesDialogActive"
    }]
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isSaveChangesLoading,
      "elevation": 0
    },
    on: {
      "click": _vm.abortChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "loading": _vm.isSaveChangesLoading,
      "disabled": !_vm.isValid,
      "elevation": 0,
      "color": "success"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")])], 1)], 1) : _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": _vm.isMobile ? false : true,
      "max-width": _vm.isMobile ? '' : 800,
      "flat": ""
    }
  }, [_c('v-card-text', {
    class: _vm.isMobile ? 'px-0' : ''
  }, [_c('invoice-form-preview', {
    attrs: {
      "value": _vm.value,
      "readonly": true
    }
  })], 1)], 1)], 1), _c('v-tab-item', {
    staticClass: "pdf-tab",
    style: _vm.isMobile ? 'height: calc(100vh - 230px);' : 'height: calc(100vh - 300px);'
  }, [_vm.value.isOutbound && (!_vm.value.document || !_vm.value.document.url) && !_vm.isLoadingBuildPdf ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("invoice.pdf.missing.title")) + " ")]), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t("invoice.pdf.missing.subtitle")) + " ")]), _c('v-card-actions', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.CREATE,
      "a": _vm.ResourceEnum.INVOICE_OUTBOUND,
      "field": _vm.value.partnerId
    }
  }, [_c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.isDocumentOutboundSelectDialog = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("invoice.pdf.addDocument")) + " ")])], 1), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.loadPreview
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("invoice.pdf.preview")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary"
    },
    on: {
      "click": _vm.buildPdf
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("invoice.pdf.build")) + " ")])], 1)], 1) : _vm.value.isInbound && (!_vm.value.document || !_vm.value.document.url) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-alert-outline",
      "text": _vm.$t('objects.invoice.missingDocument')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "outlined": ""
          },
          on: {
            "click": function click($event) {
              _vm.isDocumentSelectDialog = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.addDocument")) + " ")])];
      },
      proxy: true
    }])
  })], 1) : _vm._e(), _vm.isLoadingBuildPdf ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', {
    style: "height: ".concat(_vm.height)
  }, [_c('v-list-item', {
    staticClass: "ma-auto",
    staticStyle: {
      "max-width": "360px"
    }
  }, [_c('v-list-item-icon', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("snapshot.loadingPreview")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("snapshot.loadingPreviewSubtitle")) + " ")])], 1)], 1)], 1)], 1) : _vm.value.document && _vm.value.document.url ? _c('div', {
    staticClass: "pdf-container"
  }, [_c('iframe', {
    staticClass: "pdf",
    attrs: {
      "title": "pdf",
      "src": _vm.value.document.url
    }
  })]) : _vm.pdfPreview ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('pdf-viewer', {
    attrs: {
      "height": _vm.height,
      "pdf": _vm.pdfPreview,
      "vertical": !_vm.isMobile,
      "horizontal": _vm.isMobile
    }
  })], 1) : _vm._e()], 1), _c('v-tab-item', [_c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: true
      },
      "mail": _vm.mail
    }
  })], 1)], 1)], 1), _c('document-selection-dialog', {
    attrs: {
      "isDialogActive": _vm.isDocumentSelectDialog,
      "partnerId": _vm.value.partnerId,
      "reference": _vm.reference
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDocumentSelectDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDocumentSelectDialog = $event;
      },
      "created": _vm.onCreated
    }
  }), _c('document-selection-dialog', {
    attrs: {
      "isDialogActive": _vm.isDocumentOutboundSelectDialog,
      "partnerId": _vm.value.partnerId,
      "reference": _vm.reference
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDocumentOutboundSelectDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDocumentOutboundSelectDialog = $event;
      },
      "created": _vm.onOutboundDocumentSelected
    }
  }), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error'
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }, [_c('refs-invoice', {
    attrs: {
      "item": _vm.value
    }
  })], 1) : _vm._e(), _vm.personSideCard ? _c('person-side-card', {
    attrs: {
      "value": _vm.personSideCard
    },
    on: {
      "close": function close($event) {
        _vm.personSideCard = null;
      }
    }
  }) : _vm._e(), _vm.companySideCard ? _c('company-side-card', {
    attrs: {
      "value": _vm.companySideCard
    },
    on: {
      "close": function close($event) {
        _vm.companySideCard = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }